const INITIAL = {}

export default function cardInfo(state = INITIAL, action) {
    switch (action.type) {
        case "SET_CARDS_DATA":
            return (
                {
                    action: "EDIT",
                    data: action.data
                }
            )
        case "CREATE_CARDS_DATA":
            return (
                {
                    action: "CREATE",
                    data: {}
                }
            )
        default:
            return state;
    }
}
